import { ConsoleSalesOrigin } from './ConsoleSalesOrigin.ts';

document.addEventListener('DOMContentLoaded', () => {
	// --- 1. ターゲット要素の取得 (新仕様: Role属性ベース) ---
	// data-chart-role="container" かつ data-chart-type="console-sales-origin" の要素を検索
	const chartWrappers = document.querySelectorAll('[data-chart-role="container"][data-chart-type="console-sales-origin"]');

	chartWrappers.forEach(wrapper => {
		const initializeChart = async () => {
			// --- 2. 内部要素の取得 (新仕様: Role属性ベース) ---
			// クラス名(.console-sales-origin-area)には依存しない
			const chartArea = wrapper.querySelector('[data-chart-role="chart-area"]');
			const legendControlsContainer = wrapper.querySelector('[data-chart-role="legend"]');
			const footerControlsContainer = wrapper.querySelector('[data-chart-role="controls"]');

			if (!chartArea || !legendControlsContainer || !footerControlsContainer) {
				console.error('[console-sales-origin] Error: Required DOM elements (role=chart-area/legend/controls) not found.');
				return;
			}
			
			if (chartArea._chartInstance) {
				return; // 二重初期化防止
			}

			// --- 3. グラフインスタンスの生成 ---
			console.log('[console-sales-origin] Creating instance...');

			// ★追加: data-duration属性があれば設定に反映
			const config = {};
			if (chartArea.dataset.duration) {
				const duration = parseInt(chartArea.dataset.duration, 10);
				if (!isNaN(duration) && duration > 0) {
					config.animationDurationPerSeries = duration;
				}
			}

			// 第2引数にconfigを渡す
			const chart = new ConsoleSalesOrigin(chartArea, config);
			chartArea._chartInstance = chart;
			chartArea.dataset.chartInstance = 'true';

			// --- 4. UI用データのロード ---
			const uiData = await chart.loadDataForUI();
			if (!uiData) {
				console.error('[console-sales-origin] Error: Failed to load UI data.');
				return;
			}

			// --- 5. UI構築とイベント設定 ---

			// 状態変数
			let visibleKeys = new Set(chart.config.defaultVisibleKeys);
			let userHasInteracted = false;
			const handleUserInteraction = () => {
				if (!userHasInteracted) {
					userHasInteracted = true;
					chart.config.autoplay = false;
				}
			};

			// 5a. 凡例の生成
			const createLegend = () => {
				legendControlsContainer.innerHTML = uiData.seriesOrder.map(key => {
					const consoleLabel = key;
					const isChecked = visibleKeys.has(key);
					const checkboxId = `legend-checkbox-${chartArea.id}-${key}`;
					
					// CSSスタイリングのためにクラス名(.legend-item)は使用するが、JSロジックは依存しない
					return `
						<div class="legend-item">
							<input type="checkbox" id="${checkboxId}" value="${key}" ${isChecked ? 'checked' : ''}>
							<label for="${checkboxId}">${consoleLabel}</label>
						</div>
					`;
				}).join('');
			};

			// 5b. コントロールパネルの生成
			// ※Origin版では日付表示(current-date-display)は不要なため削除し、スライダーの刻みを細かく設定
			const createFooterControls = () => {
				footerControlsContainer.innerHTML = `
					<div class="playback-controls">
						<button class="play-pause-button" aria-label="再生/一時停止"></button>
						<input type="range" class="time-slider" min="0" max="0" value="0" step="0.1">
					</div>
					<div class="bulk-controls">
						<button class="bulk-control-button select-all">すべて選択</button>
						<button class="bulk-control-button deselect-all">すべて解除</button>
					</div>
				`;
			};

			// 5c. ボタン状態更新ヘルパー
			const updateBulkButtonsState = () => {
				const selectAllBtn = footerControlsContainer.querySelector('.select-all');
				const deselectAllBtn = footerControlsContainer.querySelector('.deselect-all');
				if (!selectAllBtn || !deselectAllBtn) return;
				selectAllBtn.disabled = visibleKeys.size === uiData.seriesOrder.length;
				deselectAllBtn.disabled = visibleKeys.size === 0;
			};

			const updateLegendCheckboxes = () => {
				legendControlsContainer.querySelectorAll('input[type="checkbox"]').forEach(cb => {
					cb.checked = visibleKeys.has(cb.value);
				});
			};

			// 初期化実行
			createLegend();
			createFooterControls();
			updateBulkButtonsState();

			// 5d. イベントリスナー
			legendControlsContainer.addEventListener('change', event => {
				if (event.target.type === 'checkbox') {
					handleUserInteraction();
					const key = event.target.value;
					if (event.target.checked) visibleKeys.add(key);
					else visibleKeys.delete(key);

					chart.setVisibleSeries(visibleKeys);
					updateBulkButtonsState();
				}
			});

			footerControlsContainer.querySelector('.play-pause-button')?.addEventListener('click', () => {
				handleUserInteraction();
				chart.togglePlayPause();
			});

			footerControlsContainer.querySelector('.time-slider')?.addEventListener('input', event => {
				handleUserInteraction();
				// 浮動小数点でシークできるようにparseFloatを使用
				chart.seek(parseFloat(event.target.value));
			});

			footerControlsContainer.querySelector('.select-all')?.addEventListener('click', () => {
				handleUserInteraction();
				visibleKeys = new Set(uiData.seriesOrder);
				chart.setVisibleSeries(visibleKeys);
				updateLegendCheckboxes();
				updateBulkButtonsState();
			});

			footerControlsContainer.querySelector('.deselect-all')?.addEventListener('click', () => {
				handleUserInteraction();
				visibleKeys.clear();
				chart.setVisibleSeries(visibleKeys);
				updateLegendCheckboxes();
				updateBulkButtonsState();
			});

			// 5e. グラフからのUI更新コールバック
			chart.onUpdateUI(state => {
				const slider = footerControlsContainer.querySelector('.time-slider');
				if (!slider) return;

				// 状態クラスはラッパーに付与（CSS制御用）
				wrapper.classList.toggle('is-playing', state.isPlaying);

				const totalFrames = state.totalFrames > 0 ? state.totalFrames - 1 : 0;
				if (parseFloat(slider.max) !== totalFrames) {
					slider.max = totalFrames;
				}
				slider.value = state.currentFrame;
			});

			// --- 6. グラフ初期化開始 ---
			chart.init();
		};

		initializeChart().catch(error => {
			console.error('[console-sales-origin] Initialization failed:', error);
		});
	});
});